import { changeExchangeApi } from "./changeExchangeApi";

export const changeExchangeSetData = async (
  lang,
  credintial,
  setMessageResponse,
  cookies,
  setBtnLoader,
  setExchange
) => {
  const response = await changeExchangeApi(credintial, lang, cookies);

  if (response.success) {
    setExchange((prev) => ({ ...prev, data: response.res.data.data }));
    setMessageResponse((prev) => ({
      ...prev,
      success: true,
      message: response.res.data.message,
      isShow: true,
    }));

    setBtnLoader(() => false);
  } else {
    const error = response.res;
    if (error.response) {
      setMessageResponse((prev) => ({
        ...prev,
        success: false,
        message: error.response.data.message,
        isShow: true,
      }));
      setBtnLoader(() => false);
    } else {
      setMessageResponse((prev) => ({
        ...prev,
        success: false,
        message: "Timeout",
        isShow: true,
      }));
      setBtnLoader(() => false);
    }
  }
};
